module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularWeb-Book.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularWeb-Book.eot
 ** module id = 352
 ** module chunks = 0
 **/